import React from "react";

const Banner = () => {
  return (
    <section className="relative overflow-hidden">
      {/* Banner Image */}
      <div
        className="
          relative
          h-[260px]
          md:h-[420px]
          w-full
        "
      >
        <img
          src="/assets/banner.jpg"
          alt="Param Life"
          className="
            w-full
            h-full
            object-cover
          "
        />

        {/* Overlay */}
        <div
          className="
            absolute
            inset-0
            bg-gradient-to-r
            from-[#24160F]/70
            via-[#24160F]/40
            to-[#24160F]/20
          "
        />

        {/* Soft Glow */}
        <div
          className="
            absolute
            top-0
            right-0
            w-80
            h-80
            bg-[#E8C8A7]/20
            blur-3xl
            rounded-full
          "
        />

        {/* Floating Card */}
        <div
          className="
            absolute
            bottom-6
            left-1/2
            -translate-x-1/2
            w-[92%]
            max-w-5xl
          "
        >
          <div
            className="
              bg-white/75
              backdrop-blur-2xl
              border
              border-white/40
              rounded-[28px]
              shadow-[0_20px_60px_rgba(20,10,0,.08)]
              px-6
              md:px-10
              py-5
              md:py-7
            "
          >
            <div className="text-center">
              <div
                className="
                  inline-flex
                  px-4
                  py-2
                  rounded-full
                  bg-[#FFF4E8]
                  border
                  border-[#F3DDC7]
                  text-primary
                  text-xs
                  uppercase
                  tracking-[.12em]
                  font-semibold
                  mb-4
                "
              >
                Holistic Wellness
              </div>

              <h2
                className="
                  text-secondary
                  text-2xl
                  md:text-4xl
                  font-bold
                  mb-3
                "
              >
                Transform Your Life From Within
              </h2>

              <p
                className="
                  text-[#5F5751]
                  text-sm
                  md:text-base
                  max-w-2xl
                  mx-auto
                  leading-7
                "
              >
                Reconnect with your mind, body, and purpose through
                immersive retreats, corporate wellness programs, and
                transformational experiences.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Spacer because card overlaps image */}
      <div className="h-20 md:h-24 bg-[#F7F1EA]" />
    </section>
  );
};

export default Banner;